var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiniEtc04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 253,
    viewBox: "0 0 259 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#44976F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_503_16039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 259,
    height: 253
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.939453,
    y: 0.310547,
    width: 258,
    height: 252,
    fill: "#D69F5E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_503_16039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.11 205.218C154.175 212.451 168.875 213.563 178.21 213.563C185.99 213.123 188.833 209.397 188.572 207.782C188.096 204.85 189.128 203.022 185.08 198.626C181.033 194.23 157.451 179.211 146.012 174.266C134.573 169.321 122.068 167.192 117.327 171.885C114.037 175.141 114.679 180.76 117.327 185.792C119.38 189.7 128.11 199.047 140.11 205.218Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.608 144.05C244.235 154.955 258.681 153.998 264.88 153.998C275.406 153.674 278.883 148.978 278.64 147.565C278.2 145.002 279.156 143.403 275.406 139.559C271.655 135.715 249.806 122.583 239.207 118.259L239.159 118.239C228.565 113.917 214.348 108.116 209.962 112.213C206.914 115.061 208.284 123.845 210.737 128.246C213.19 132.646 216.114 137.558 226.608 144.05Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9555 135.87C89.7527 132.887 87.1816 126.727 87.1816 121.074C87.4793 113.29 89.5293 118.314 91.0836 118.314C92.6379 118.314 96.2051 124.79 97.2413 130.259C98.2775 135.729 122.907 162.256 102.836 147.399C97.614 143.534 94.126 138.81 91.9857 135.911L91.9555 135.87Z",
    fill: "#0F0D22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.502 172.355L141.033 164.543L144.098 166.713C145.873 167.969 146.117 169.787 145.028 171.324C143.924 172.883 142.128 173.224 140.326 171.948L138.923 170.955L137.12 173.501L135.502 172.355ZM139.848 169.649L140.992 170.459C141.952 171.139 142.803 170.932 143.356 170.14C143.911 169.367 143.812 168.511 142.856 167.826L141.712 167.016L139.848 169.649Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.857 177.709C142.35 177.349 142.226 176.654 142.592 176.16C142.933 175.656 143.629 175.542 144.133 175.907C144.617 176.241 144.746 176.94 144.394 177.436C144.039 177.938 143.337 178.048 142.857 177.709Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.138 179.178L150.669 171.365L153.733 173.535C155.508 174.792 155.753 176.609 154.664 178.147C153.56 179.706 151.764 180.046 149.962 178.77L148.559 177.777L146.756 180.324L145.138 179.178ZM149.484 176.471L150.627 177.281C151.588 177.961 152.439 177.754 152.991 176.963C153.547 176.189 153.448 175.334 152.492 174.648L151.348 173.839L149.484 176.471Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.118 177.348L153.586 185.16L151.989 184.029L157.521 176.217L159.118 177.348Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.398 188.036C155.605 186.759 155.326 184.82 156.645 182.968C157.919 181.156 159.903 180.722 161.619 181.937C163.157 183.026 163.683 184.857 162.269 186.853L161.949 187.306L157.945 184.471C157.319 185.356 157.456 186.272 158.278 186.862C158.827 187.242 159.383 187.28 159.788 187.04L161.309 188.117C160.315 189.041 158.847 189.055 157.398 188.036ZM158.656 183.468L161.148 185.233C161.647 184.517 161.519 183.657 160.803 183.158C160.073 182.633 159.166 182.817 158.656 183.468Z",
    fill: "#AAA0E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.902 206.25C157.48 212.959 171.671 213.99 180.684 213.991C188.194 213.582 190.94 210.126 190.687 208.628C190.228 205.908 191.224 204.212 187.317 200.135C183.409 196.057 160.643 182.126 149.599 177.539C138.556 172.952 126.483 170.978 121.906 175.33C118.73 178.351 119.35 183.563 121.906 188.231C123.888 191.855 132.316 200.525 143.902 206.25Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.954 139.63C251.32 151.197 266.373 150.183 272.832 150.183C283.799 149.839 287.422 144.857 287.169 143.359C286.711 140.639 287.706 138.943 283.799 134.865C279.891 130.788 257.125 116.857 246.081 112.27L246.031 112.249C234.993 107.664 220.18 101.511 215.61 105.857C212.433 108.877 213.861 118.196 216.417 122.864C218.974 127.533 222.019 132.743 232.954 139.63Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5093 130.834C85.5277 128.074 83.2148 122.375 83.2148 117.145C83.4827 109.943 85.3267 114.591 86.7249 114.591C88.1231 114.591 91.3321 120.583 92.2643 125.643C93.1964 130.704 115.352 155.247 97.2968 141.501C92.5995 137.925 89.4618 133.554 87.5364 130.872L87.5093 130.834Z",
    fill: "#17161E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9277 115.643C83.7264 132.714 106.971 149.52 118.493 155.79L118.032 136.45C114.218 133.816 105.449 128.63 94.6429 119.004C85.9977 111.304 83.2306 97.5728 82.9277 91.6699V115.643Z",
    fill: "#8D3D02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.526 155.818L118.049 136.919L121.659 134.299L121.856 152.724L118.526 155.818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.104 152.734L118.785 139.647L121.104 137.75L121.281 150.762L119.104 152.734Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.104 152.728L118.785 139.641L129.699 145.743L128.162 157.796L119.104 152.728Z",
    fill: "#B66021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.261 77.3616C253.277 75.9008 252.988 72.5315 251.703 70.7402",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.136 77.119C254.444 75.4799 254.701 71.5494 253.26 68.9395",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.712 208.473C197.228 208.819 195.763 209.192 193.771 207.92",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.048 207.332C198.584 207.582 197.401 207.839 196.379 206.865",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.206 187.883C208.51 188.057 206.443 188.3 203.75 187.883",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.376 186.492C208.642 186.685 206.72 186.956 204.908 186.492",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.525 198.504C197.962 199.26 199.28 200.849 201.063 201.157",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.943 197.619C198.2 198.234 199.12 199.518 200.75 199.734",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.828 127.374C156.761 126.521 150.077 131.289 147.744 133.78C154.309 154.939 163.077 198.991 164.026 205.541C165.213 213.727 190.381 215.456 197.619 208.812C203.519 204.014 209.041 194.741 209.913 182.544C210.625 172.583 204.693 154.781 195.201 144.103C185.71 133.425 174.913 128.441 164.828 127.374Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.291 132.007C146.795 132.875 146.552 135.096 145.416 136.554C156.417 161.128 176.628 210.024 180.23 211.156C184.733 212.572 194.998 206.464 198.485 195.319C201.619 186.699 200.097 174.864 197.433 167.598C192.285 153.556 181.825 141.675 171.538 135.724C161.054 129.66 151.843 131.621 150.291 132.007Z",
    fill: "#8D3D02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.799 133.175L132.512 142.56C132.371 155.952 134.465 185.214 143.98 195.13C155.872 207.525 166.174 210.289 175.135 211.713C184.097 213.137 189.765 206.873 191.457 204.844L191.505 204.786C193.908 201.905 200.028 194.566 198.069 177.398C193.432 156.008 179.853 143.574 170.41 137.511C162.045 132.139 151.971 132.084 147.799 133.175Z",
    fill: "#DF8654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.833 145.812L118.785 139.647L121.104 137.75L132.01 143.84L129.833 145.812Z",
    fill: "#DFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.274 94.3674L224.27 69.3802L227.4 66.1738L227.404 91.4132L224.274 94.3674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.914 89.5171C102.114 97.1926 94.7332 110.352 96.44 117.402C90.8721 111.822 88.8287 109.032 88.2903 106.428C86.5839 100.367 83.317 90.2269 91.5071 81.929C101.745 71.5567 114.086 65.2989 132.589 60.9301C148.149 57.2561 169.269 55.8558 189.333 58.5772C205.643 60.7896 220.184 65.8378 224.27 68.846V94.1209C218.504 92.249 212.932 89.4689 185.991 83.6773C159.05 77.8858 134.394 80.452 116.914 89.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.608 139.873C125.405 140.736 124.851 157.954 125.856 166.64C127.579 176.188 132.307 183.224 137.737 189.765C155.006 209.665 170.9 206.43 174.493 204.554C178.296 202.567 187.515 194.13 184.974 179.93C183.022 169.018 173.664 157.413 169.611 153.297C165.489 149.109 154.714 139.073 140.608 139.873Z",
    fill: "#DF8654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.088 148.731C125.352 148.978 125.84 163.594 128.051 170.871C133.452 186.688 147.431 197.623 152.967 200.026C159.257 202.757 172.637 202.109 175.799 193.006C178.962 183.904 174.99 175.166 174.242 173.52C173.858 172.677 160.758 148.423 141.088 148.731Z",
    fill: "#8D3D02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.862 78.6224L224.814 72.4574L227.133 70.5605L238.039 76.651L235.862 78.6224Z",
    fill: "#DFCDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.133 89.9403L224.814 72.457L235.728 78.5589L234.191 95.0087L225.133 89.9403Z",
    fill: "#B66021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.687 134.294L118.046 136.914C97.7012 126.482 88.3438 114.12 85.0759 105.346C78.9878 89.0084 87.6161 80.857 92.6895 76.1368C98.5336 70.2349 115.374 58.7691 138.928 55.7135C151.372 54.0993 161.285 53.1432 175.833 53.9921C204.573 56.1387 222.165 62.9929 227.383 66.173L224.23 69.4044C220.891 67.4963 208.825 63.5656 202.96 62.2406C194.273 60.4361 172.687 57.148 155.847 58.4311C134.796 60.0349 125.65 62.5424 121.64 64.1462C117.63 65.7501 106.748 69.0917 97.8602 76.7101C89.8938 83.5384 87.7829 87.5527 87.1635 91.613C85.2171 111.822 110.084 128.662 121.687 134.294Z",
    fill: "#DFCDC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.159 108.511C214.97 106.535 216.726 100.399 217.628 97.5781L220.333 102.634L232.797 121.8C241.262 126.895 258.288 137.156 258.665 137.438C259.041 137.72 280.613 136.458 291.353 135.792C296.33 132.186 305.862 126.15 304.169 130.853C302.053 136.733 293.116 150.607 267.131 149.549C241.145 148.491 227.129 134.048 221.598 126.586C216.416 119.592 215.394 110.982 215.159 108.511Z",
    fill: "#DF8654"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.223,
    cy: 106.248,
    rx: 48.7072,
    ry: 36.4962,
    transform: "rotate(22.8984 263.223 106.248)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 129.054C232.316 127.719 233.11 124.732 234.663 123.471",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.137,
    cy: 100.172,
    rx: 22.8571,
    ry: 13.8908,
    transform: "rotate(22.8984 264.137 100.172)",
    fill: "#592A10"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.405,
    cy: 103.321,
    rx: 19.537,
    ry: 11.8731,
    transform: "rotate(22.8984 266.405 103.321)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.332 119.809C275.711 127.149 293.416 124.538 297.877 113.977C302.338 103.415 291.866 88.9025 274.487 81.5619C257.108 74.2213 239.403 76.8324 234.942 87.394C230.481 97.9557 240.953 112.468 258.332 119.809ZM261.791 111.624C271.73 115.822 281.856 114.329 284.408 108.288C286.959 102.247 280.97 93.9471 271.03 89.7487C261.091 85.5503 250.964 87.0438 248.413 93.0843C245.862 99.1249 251.851 107.425 261.791 111.624Z",
    fill: "#8D3D02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.539 102.331C217.052 100.338 218.863 96.0075 222 94.627",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.482 106.962C217.725 105.181 218.708 101.376 220.699 100.406",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.598 127.842C231.023 125.657 232.759 120.62 236.302 117.949",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.162 126.484C229.275 124.407 230.334 119.865 233.668 118.316",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.29 119.91C258.326 121.33 258.032 124.655 256.564 126.597",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.84 136.547C186.23 136.633 184.915 137.078 184.537 138.168",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.845 135.74C184.9 136.065 182.816 137.055 182.039 138.414",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.037 156.818C202.319 157.038 200.467 157.727 198.809 158.723",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.843 157.887C203.291 158.072 201.95 158.622 201.01 159.34",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.18 131.471C160.104 130.763 160.352 129.157 161.944 128.396",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.088 131.74C161.134 131.212 161.452 130.047 162.356 129.613",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.707 137.484C174.918 136.85 175.603 135.537 176.652 135.357",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.859 152.777C190.372 152.098 191.732 150.688 193.071 150.471",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.219 153.323C190.701 152.84 191.866 151.82 192.662 151.604",
    stroke: "#29292C",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.889 167.282L144.551 161.129L146.863 163.632C148.273 165.159 148.096 166.832 146.822 168.018C145.543 169.19 143.858 169.221 142.438 167.684L141.248 166.396L138.994 168.479L137.889 167.282ZM142.233 165.487L143.27 166.609C144.107 167.507 144.987 167.444 145.691 166.794C146.404 166.135 146.523 165.276 145.69 164.374L144.653 163.252L142.233 165.487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.518 173.525C143.153 173.129 143.173 172.505 143.573 172.144C143.955 171.782 144.575 171.816 144.945 172.207C145.293 172.593 145.277 173.213 144.891 173.57C144.495 173.936 143.871 173.906 143.518 173.525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.343 175.352L152.005 169.198L154.316 171.701C155.727 173.229 155.55 174.901 154.275 176.087C152.997 177.26 151.311 177.291 149.892 175.754L148.702 174.466L146.448 176.548L145.343 175.352ZM149.687 173.556L150.724 174.679C151.561 175.576 152.441 175.514 153.145 174.864C153.858 174.205 153.976 173.345 153.144 172.444L152.107 171.321L149.687 173.556Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.413 176.136L151.751 182.29L150.663 181.112L157.325 174.959L158.413 176.136Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.735 185.723C153.346 184.219 153.495 182.368 155.059 180.923C156.605 179.495 158.52 179.465 159.838 180.891C160.968 182.115 161.177 183.883 159.425 185.502L159.056 185.842L155.835 182.354C155.001 183.159 154.958 184.128 155.664 184.883C156.135 185.402 156.675 185.543 157.114 185.419L158.177 186.569C157.116 187.156 155.806 186.883 154.735 185.723ZM156.64 181.619L158.82 183.98C159.497 183.346 159.569 182.427 158.944 181.751C158.294 181.047 157.313 181.074 156.64 181.619Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.607 242.311V222.514H190.373C194.871 222.514 197.455 225.289 197.455 229.186C197.455 233.137 194.83 235.857 190.264 235.857H186.709V242.311H182.607ZM186.709 232.549H189.607C192.041 232.549 193.23 231.182 193.217 229.186C193.23 227.217 192.041 225.891 189.607 225.877H186.709V232.549ZM201.42 242.557C200.135 242.557 199.096 241.531 199.123 240.26C199.096 239.002 200.135 237.977 201.42 237.99C202.637 237.977 203.689 239.002 203.689 240.26C203.689 241.531 202.637 242.557 201.42 242.557ZM207.025 242.311V222.514H214.791C219.289 222.514 221.873 225.289 221.873 229.186C221.873 233.137 219.248 235.857 214.682 235.857H211.127V242.311H207.025ZM211.127 232.549H214.025C216.459 232.549 217.648 231.182 217.635 229.186C217.648 227.217 216.459 225.891 214.025 225.877H211.127V232.549ZM228.436 222.514V242.311H224.389V222.514H228.436ZM238.307 242.611C233.754 242.598 230.965 239.658 230.979 234.955C230.965 230.375 233.795 227.271 238.143 227.271C242.039 227.271 245.115 229.732 245.115 234.791V235.939H234.971C234.971 238.182 236.297 239.562 238.389 239.576C239.77 239.562 240.754 238.961 241.15 238.072H245.006C244.432 240.82 241.971 242.598 238.307 242.611ZM234.971 233.396H241.287C241.273 231.592 240.029 230.293 238.225 230.307C236.365 230.293 235.053 231.688 234.971 233.396Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniEtc04);
export default __webpack_public_path__ + "static/media/mini_etc_04.e2411907288d9192ef18a7796cf8c350.svg";
export { ForwardRef as ReactComponent };